import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  ProjectClusterStoreActions,
  ProjectClusterStoreSelectors,
  ProjectClusterStoreReducer,
} from './index';
import { ProjectClusterDto } from '@cradua/data';

@Injectable()
export class ProjectClusterFacade {
  constructor(
    private store: Store<ProjectClusterStoreReducer.ProjectClusterPartialState>
  ) {}

  projectManagementRecord$ = this.store.select(
    ProjectClusterStoreSelectors.getSelected
  );
  searchedStudentRecord$ = this.store.select(
    ProjectClusterStoreSelectors.getSearchStudentRecord
  );

  projectManagementRecordError$ = this.store.select(
    ProjectClusterStoreSelectors.getProjectClusterError
  );

  getselected() {
    return this.store.select(ProjectClusterStoreSelectors.getSelected);
  }

  get isLoadingProjectCluster() {
    this.store.dispatch(ProjectClusterStoreActions.loadProjectCluster());
    return this.store.select(
      ProjectClusterStoreSelectors.loadingProjectCluster
    );
  }

  get loadProjectCluster() {
    this.store.dispatch(ProjectClusterStoreActions.loadProjectCluster());
    return this.store.select(ProjectClusterStoreSelectors.getAllProjectCluster);
  }

  searchProjectClusterRecord(query) {
    this.store.dispatch(
      ProjectClusterStoreActions.searchProjectClusterRecord({ query })
    );
  }

  addProjectCluster(newProjectCluster: ProjectClusterDto[]) {
    this.store.dispatch(
      ProjectClusterStoreActions.addProjectCluster({
        newProjectCluster,
      })
    );
  }

  updateProjectCluster(updateProjectCluster: ProjectClusterDto[]) {
    this.store.dispatch(
      ProjectClusterStoreActions.updateProjectCluster({
        updateProjectCluster,
      })
    );
  }

  removeProjectCluster(ids: string[]) {
    this.store.dispatch(
      ProjectClusterStoreActions.removeProjectCluster({ ids })
    );
  }
}
